// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"ChatSearch_searchBox__I348p","chatInput":"ChatSearch_chatInput__2uzq4"};